const defaultStateFactory = () => ({
    subjects: [],
    topics: [],
    testTopicStatistics: [],
});
export default defaultStateFactory;
